import React, { useMemo, useState } from "react";
import {
  TextArea,
  MyMessage,
  InputField,
  MyButton,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { codeOk } from "../../../lib/index";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { getOneNightlife } from "../../../lib/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../components/Pricing";
import GenerateDescription from "../utils/GenerateDescription";
import { FaHandSparkles } from "react-icons/fa";
import {
  ContactSection,
  SocialSection,
  GeoSection,
  VisibilitySection,
} from "../utils/AddSections";
import {
  FiImage,
  FiAlignLeft,
  FiCalendar,
  FiDollarSign,
  FiMoon,
} from "react-icons/fi";

const slugify = (str = "") =>
  str
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "_")
    .replace(/_+/g, "_");

const dayOptions = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
  "annual",
];

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const nightlife: any = getOneNightlife() || {};
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const nightlife_id = nightlife?.nightlife_id;

  const [thumbnail, setThumbnail] = useState<any>(
    nightlife?.thumbnail || defaultImage
  );
  const [thumbnailId, setThumbnailId] = useState<any>(
    nightlife?.image_cdn_id || ""
  );

  const [title, setTitle] = useState<any>(nightlife?.title || "");
  const [venue, setVenue] = useState<any>(nightlife?.venue || "");

  const [startDate, setStartDate] = useState<any>(nightlife?.start_date || "");
  const [endDate, setEndDate] = useState<any>(nightlife?.end_date || "");
  const [startTime, setStartTime] = useState<any>(nightlife?.start_time || "");
  const [endTime, setEndTime] = useState<any>(nightlife?.end_time || "");

  const [email, setEmail] = useState<any>(nightlife?.email_address || "");
  const [payLink, setPayLink] = useState<any>(nightlife?.pay_link);
  const [phoneNumber, setPhoneNumber] = useState<any>(
    nightlife?.phone_number || ""
  );
  const [whatsapp, setWhatsapp] = useState<any>(nightlife?.whatsapp || "none");
  const [facebook, setFacebook] = useState<any>(nightlife?.facebook || "none");
  const [twitter, setTwitter] = useState<any>(nightlife?.twitter || "none");
  const [instagram, setInstagram] = useState<any>(
    nightlife?.instagram || "none"
  );
  const [youtube, setYoutube] = useState<any>(nightlife?.youtube || "none");

  const [hashtags, setHashtags] = useState<any>(nightlife?.hashtag || "");
  const [googleMapCode, setGoogleMapCode] = useState<any>(
    nightlife?.google_map_code || "none"
  );
  const [latitude, setLatitude] = useState<any>(nightlife?.latitude || "none");
  const [longitude, setLongitude] = useState<any>(
    nightlife?.longitude || "none"
  );
  const [formattedAddress, setFormattedAddress] = useState<any>(
    nightlife?.formatted_address || ""
  );

  const [featured, setFeatured] = useState<any>(nightlife?.featured ?? "no");
  const [promoted, setPromoted] = useState<any>(
    nightlife?.promoted ? nightlife.promoted : "no"
  );
  const [nightlifeStatus, setNightlifeStatus] = useState<any>(
    nightlife?.status ?? 1
  );
  const [description, setDescription] = useState<any>(
    nightlife?.description || ""
  );
  const [repeatEvery, setRepeatEvery] = useState<any>(
    nightlife?.repeat_every || ""
  );
  const [expo, setExpo] = useState<any>(nightlife?.expo ?? 0);
  const [pricing, setPricing] = useState<any>(nightlife?.Pricings || []);

  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(false);
  const nightlifeRoutes = "/data/nightlife";

  const responses = (isError: any, msg: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(msg || "");
  };

  const isDaySelected = (val: string) =>
    (repeatEvery || "").toString().split("|").filter(Boolean).includes(val);

  const toggleRepeat = (val: string) => {
    const parts = repeatEvery
      ? repeatEvery.split("|").filter(Boolean)
      : [];
    const exists = parts.includes(val);
    const next = exists
      ? parts.filter((x: string) => x !== val)
      : [...parts, val];
    setRepeatEvery(next.join("|"));
  };

  const canSubmit = useMemo(() => {
    if (!title || !thumbnail || !thumbnailId) return false;
    if (startDate && endDate) {
      const sd = new Date(`${startDate}T${startTime || "00:00"}`);
      const ed = new Date(`${endDate}T${endTime || "23:59"}`);
      if (sd > ed) return false;
    }
    return true;
  }, [title, thumbnail, thumbnailId, startDate, endDate, startTime, endTime]);

  const updateOneNightlifeHandler = async (e: any) => {
    e.preventDefault();

    if (!thumbnail || !thumbnailId) {
      responses(true, "Profile image is required.");
      return;
    }
    if (!title) {
      responses(true, "Title is required.");
      return;
    }
    if (startDate && endDate) {
      const sd = new Date(`${startDate}T${startTime || "00:00"}`);
      const ed = new Date(`${endDate}T${endTime || "23:59"}`);
      if (sd > ed) {
        responses(true, "Start date/time must be before end date/time.");
        return;
      }
    }

    setLoading(true);
    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ?? nightlife?.country_id,
      first_level_id: first_level_id || 0,
      second_level_id: second_level_id || 0,
      third_level_id: third_level_id || 0,
      fourth_level_id: fourth_level_id || 0,

      title,
      slug: title ? slugify(title) : null,
      description,

      venue,
      start_date: startDate,
      end_date: endDate,
      start_time: startTime,
      end_time: endTime,

      thumbnail: thumbnail || defaultImage,
      image_cdn_id: thumbnailId || "",

      phone_number: phoneNumber || null,
      email_address: email || null,
      pay_link: payLink,
      whatsapp,
      facebook,
      twitter,
      instagram,
      youtube,

      hashtag: hashtags,
      audio_adv: "none",

      google_map_code: googleMapCode,
      latitude,
      longitude,
      formatted_address: formattedAddress || null,
      country_short: "none",

      status: nightlifeStatus,
      featured,
      promoted,
      repeat_every: repeatEvery,
      expo,
      pricing,
    };

    const { message, status } = await updateOneContent({
      data_id: nightlife_id,
      data,
      content: _TYPES_.NIGHTLIFE,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === codeOk || status === 200)
      responses(false, message || "Updated.");
    else responses(true, message || "Failed to update.");
  };

  const clearMessages = () => {
    setError(null as any);
    setSuccess(null as any);
  };

  return (
    <AddPageShell
      backRoute={nightlifeRoutes}
      eyebrow="DoSee Data • Nightlife"
      title="Edit Nightlife"
      subtitle={`Update an after-dark spot in ${entry_label || "this destination"}.`}
      icon={<FiMoon className="h-5 w-5" />}
      modals={
        showDescriptionModal ? (
          <GenerateDescription
            setDescription={setDescription}
            setShowDescriptionModal={setShowDescriptionModal}
          />
        ) : null
      }
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneNightlifeHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage("");
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="The hero shot travellers see first."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.NIGHTLIFE)}
        />
      </AddSection>

      <AddSection title="Basics" hint="Name, venue and address.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              value: title,
              onChange: (e: any) => {
                setTitle(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue",
              title: "Venue",
              type: "text",
              value: venue,
              onChange: (e: any) => {
                setVenue(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "formatted_address",
              title: "Formatted Address",
              type: "address",
              value: formattedAddress,
              onChange: (e: any) => {
                setFormattedAddress(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Date & Time"
        hint="Optional schedule and recurring days."
        icon={<FiCalendar className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <InputField
            props={{
              id: "start_date",
              title: "Start Date",
              type: "date",
              value: startDate,
              onChange: (e: any) => {
                setStartDate(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "end_date",
              title: "End Date",
              type: "date",
              value: endDate,
              onChange: (e: any) => {
                setEndDate(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "start_time",
              title: "Start Time",
              type: "time",
              value: startTime,
              onChange: (e: any) => {
                setStartTime(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "end_time",
              title: "End Time",
              type: "time",
              value: endTime,
              onChange: (e: any) => {
                setEndTime(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
        <div className="mt-5">
          <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-500">
            Repeat Every
          </p>
          <div className="flex flex-wrap gap-3">
            {dayOptions.map((val) => (
              <button
                key={val}
                type="button"
                onClick={() => toggleRepeat(val)}
                className={[
                  "inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-medium capitalize transition",
                  isDaySelected(val)
                    ? "border-brand bg-brand/10 text-brand"
                    : "border-gray-200 bg-white text-gray-700 hover:bg-gray-50",
                ].join(" ")}
              >
                {isDaySelected(val) ? (
                  <MdCheckBox className="h-4 w-4" />
                ) : (
                  <MdCheckBoxOutlineBlank className="h-4 w-4" />
                )}
                {val}
              </button>
            ))}
          </div>
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Optional pricing tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <ContactSection
        phone={phoneNumber}
        setPhone={setPhoneNumber}
        email={email}
        setEmail={setEmail}
        payLink={payLink}
        setPayLink={setPayLink}
        clearMessages={clearMessages}
      />

      <SocialSection
        whatsapp={whatsapp}
        setWhatsapp={setWhatsapp}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
        clearMessages={clearMessages}
      />

      <GeoSection
        googleMapCode={googleMapCode}
        setGoogleMapCode={setGoogleMapCode}
        latitude={latitude}
        setLatitude={setLatitude}
        longitude={longitude}
        setLongitude={setLongitude}
        clearMessages={clearMessages}
      />

      <VisibilitySection
        statusId="nightlife_status"
        setStatus={setNightlifeStatus}
        setFeatured={setFeatured}
        setPromoted={setPromoted}
        setExpo={setExpo}
        status={nightlifeStatus}
        featured={featured}
        promoted={promoted}
        expo={expo}
        clearMessages={clearMessages}
      />

      <AddSection
        title="Description"
        hint="Vibe, dress code, music style — whatever travellers should know."
        icon={<FiAlignLeft className="h-4 w-4" />}
        actions={
          <MyButton
            onClick={() => setShowDescriptionModal(true)}
            className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-br from-brand to-primary px-3 py-2 text-xs font-semibold text-white shadow hover:opacity-95"
          >
            <FaHandSparkles className="h-4 w-4" />
            Generate
          </MyButton>
        }
      >
        <TextArea
          props={{
            id: "description",
            title: "Description",
            type: "text",
            value: description,
            onChange: (e: any) => {
              setDescription(e.target.value);
              clearMessages();
            },
          }}
        />
        <div className="mt-4">
          <InputField
            props={{
              id: "hashtag",
              title: "Tags (comma separated)",
              type: "text",
              value: hashtags,
              onChange: (e: any) => {
                setHashtags(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <button
        type="submit"
        className="hidden"
        disabled={!canSubmit || loading}
      />
    </AddPageShell>
  );
};

export default Edit;
